export default __webpack_public_path__ + "static/1283-796ff236df4cd4fc8bf417d75c577dc9.gif";